import actionTypes from 'constants/actionTypes'

interface BasicAction {
  type: string
  [key: string]: unknown
}

type ReducerFunction<TState> = (state: TState | undefined, action: BasicAction) => TState

export const loggedIn = <TState>(reducer: ReducerFunction<TState>) => {
  return (state: TState | undefined, action: BasicAction): TState => {
    const actionType = action.type
    if (
      [
        actionTypes.AUTH.LOGOUT.REQUEST,
        actionTypes.AUTH.LOGOUT.RECEIVE,
        actionTypes.AUTH.LOGOUT.FAIL
      ].includes(actionType)
    ) {
      return reducer(undefined, { type: '' })
    }

    return reducer(state, action)
  }
}
